import { React, useEffect, useRef, useState } from "react";
import ReactECharts from "echarts-for-react"; // or var ReactECharts = require('echarts-for-react');
import TripPopup from "components/trip_and_charge_component/TripPopup";
import * as echarts from "echarts";
import moment from "moment";
// Import the echarts core module, which provides the necessary interfaces for using echarts.
// import * as echarts from 'echarts/core';
// Import charts, all with Chart suffix
import {
  // LineChart,
  // BarChart,
  // PieChart,
  // ScatterChart,
  // RadarChart,
  // MapChart,
  // TreeChart,
  // TreemapChart,
  // GraphChart,
  // GaugeChart,
  // FunnelChart,
  // ParallelChart,
  // SankeyChart,
  // BoxplotChart,
  // CandlestickChart,
  // EffectScatterChart,
  // LinesChart,
  // HeatmapChart,
  // PictorialBarChart,
  // ThemeRiverChart,
  // SunburstChart,
  CustomChart,
} from "echarts/charts";
// import components, all suffixed with Component
import {
  // GridSimpleComponent,
  GridComponent,
  // PolarComponent,
  // RadarComponent,
  // GeoComponent,
  // SingleAxisComponent,
  // ParallelComponent,
  // CalendarComponent,
  // GraphicComponent,
  ToolboxComponent,
  TooltipComponent,
  // AxisPointerComponent,
  // BrushComponent,
  TitleComponent,
  // TimelineComponent,
  // MarkPointComponent,
  // MarkLineComponent,
  // MarkAreaComponent,
  // LegendComponent,
  // LegendScrollComponent,
  // LegendPlainComponent,
  DataZoomComponent,
  DataZoomInsideComponent,
  DataZoomSliderComponent,
  // VisualMapComponent,
  // VisualMapContinuousComponent,
  // VisualMapPiecewiseComponent,
  // AriaComponent,
  // TransformComponent,
  // DatasetComponent,
} from "echarts/components";
// Import renderer, note that introducing the CanvasRenderer or SVGRenderer is a required step
import {
  CanvasRenderer,
  // SVGRenderer,
} from "echarts/renderers";
// import { useAbsoluteLayout } from 'react-table';
// import { create } from 'react-test-renderer';

// import useComponentSize from '@rehooks/component-size'
// var option;
// var vehicleId= 0;
var scheduleid = 0;
// var make =1;
// var model =2;
var startTime = 1;
var endTime = 2;
var name = 3;
var HEIGHT_RATIO = 0.3;
var _draggable;
// var HEIGHT_RATIO = 0.6;
// var DIM_CATEGORY_INDEX = 0;
// var DIM_TIME_ARRIVAL = 1;
// var DIM_TIME_DEPARTURE = 2;
// var DATA_ZOOM_AUTO_MOVE_THROTTLE = 30;
// var DATA_ZOOM_X_INSIDE_INDEX = 1;
// var DATA_ZOOM_Y_INSIDE_INDEX = 3;
// var DATA_ZOOM_AUTO_MOVE_SPEED = 0.2;
// var DATA_ZOOM_AUTO_MOVE_DETECT_AREA_WIDTH = 30;
// var _draggable = true;
// var _draggingEl;
// var _dropShadow;
// var _draggingCursorOffset = [0, 0];
// var _draggingTimeLength;
// var _draggingRecord;
// var _dropRecord;
// var _cartesianXBounds = [];
// var _cartesianYBounds = [];
// var _autoDataZoomAnimator;
function onDragSwitchClick(model, api, type) {
  _draggable = !_draggable;
  CustomChart.setOption({
    dataZoom: [
      {
        id: "insideX",
        disabled: _draggable,
      },
    ],
  });
  this.model.setIconStatus(type, _draggable ? "emphasis" : "normal");
}
var day;
var tripSchedule;
var rowCount;
var osCheck;
var graphWidth = 0;
const Gantt = (props) => {
  day = props?.day;
  graphWidth = props?.graphWidth1;
  //  osCheck=window?.navigator?.platform;
  rowCount = props?.rowDataTable?.length;
  var ukDate = process.env.REACT_APP_UNITS_SYSTEM;
  // R egister the required components
  echarts.registerTheme("my_theme", {
    backgroundColor: "#f4cccc",
  });

  tripSchedule = props.chargerTripShedule;

  echarts.use([
    ToolboxComponent,
    TitleComponent,
    TooltipComponent,
    GridComponent,
    CustomChart,
    CanvasRenderer,
    DataZoomComponent,
    DataZoomInsideComponent,
    DataZoomSliderComponent,
  ]);

  var rawData = {
    vehicleList: {
      dimensions: ["id", "make", "model"],
      // "data": chargerdata
      data: props?.rowChargerList,
    },
    vehicleSchedule: {
      dimensions: ["id", "scheduleStart", "scheduleEnd", "name"],
      // "data": props?.scheduleValue !== undefined ? props?.scheduleValue : charListVal
      data: props?.rowChargerGraph,
    },
    chargerList: {
      dimensions: ["id", "make", "model"],
      // "data": chargerdata
      data: props?.rowChargerList,
    },
    chargerSchedule: {
      dimensions: ["id", "scheduleStart", "scheduleEnd", "name"],
      data: props?.rowChargerGraph,
      // "data": props?.scheduleValue !== undefined ? props?.scheduleValue : charListVal
    },
  };
  const options = () => ({
    tooltip: {
      show: false,
    },
    animation: false,
    toolbox: {
      left: 20,
      top: 0,
      itemSize: 20,
    },
    title: {
      show: false,
      text: "Gantt of vehicle list",
      left: "center",
    },
    dataZoom: [
      // {
      //     type: 'inside',
      //     zoomOnMouseWheel: false,
      //     xAxisIndex: 0,
      //     zoomLock: true,
      //     // right: 10,
      //     width: 0,
      //     height: 0,
      //     start: 0,
      //     end: 100,
      // },
      // {
      //     type: 'slider',
      //     start: 10,
      //     end: 40,
      //     top: 0,
      //     width: 0,
      // },
      // {
      //     type: 'inside',
      //     yAxisIndex: 0,
      //     zoomOnMouseWheel: false,
      //     moveOnMouseWheel: false,
      //     zoomLock: false,
      //     width: 0,
      //     handleSize: 0,
      //     // bottom:20,
      //     start: 0,
      //     end: 100,
      // },
      // {
      //     type: 'slider',
      //     right: 0,
      //     id: 'insideY',
      //     yAxisIndex: 0,
      //     width: 0,
      //     handleSize: 0,
      //     // fillerColor: 'rgba(38,143,26,0.6)'
      // },
    ],
    //calculable: true,
    grid: {
      top: 59,
      bottom: 20,
      // (props?.letList / 100) * (day===0?90 + ((day + day) * 13):day===1?85 + ((day + day) * 13):day===2?83 + ((day + day) * 13):day===3?78 + ((day + day) * 13):day===4?75 + ((day + day) * 13):day===5?69 + ((day + day) * 13):62 + ((day + day) * 13))
      left:
        window.screen.width <= 1399
          ? (props?.letList / 100) *
            (day === 0
              ? 93 + (day + day) * 13
              : day === 1
              ? 85 + (day + day) * 13
              : day === 2
              ? 75 + (day + day) * 13
              : day === 3
              ? 65 + (day + day) * 13
              : day === 4
              ? 55 + (day + day) * 13
              : day === 5
              ? 45 + (day + day) * 13
              : 35 + (day + day) * 13)
          : window.screen.width <= 1450
          ? (props?.letList / 100) *
            (day === 0
              ? 92 + (day + day) * 13
              : day === 1
              ? 85 + (day + day) * 13
              : day === 2
              ? 82 + (day + day) * 13
              : day === 3
              ? 75 + (day + day) * 13
              : day === 4
              ? 66 + (day + day) * 13
              : day === 5
              ? 58 + (day + day) * 13
              : 48 + (day + day) * 13)
          : window.screen.width <= 1680
          ? (props?.letList / 100) *
            (day === 0
              ? 95 + (day + day) * 13
              : day === 1
              ? 90 + (day + day) * 13
              : day === 2
              ? 83 + (day + day) * 13
              : day === 3
              ? 78 + (day + day) * 13
              : day === 4
              ? 72 + (day + day) * 13
              : day === 5
              ? 67 + (day + day) * 13
              : 60 + (day + day) * 13)
          : // :window.screen.width <= 1680?(props?.letList / 100) * (day===0?95 + ((day + day) * 13):day===1?90 + ((day + day) * 13):day===2?85 + ((day + day) * 13):day===3?82 + ((day + day) * 13):day===4?77 + ((day + day) * 13):day===5?75 + ((day + day) * 13):68 + ((day + day) * 13))
            (props?.letList / 100) *
            (day === 0
              ? 99 + (day + day) * 13
              : day === 1
              ? 95 + (day + day) * 13
              : day === 2
              ? 90 + (day + day) * 13
              : day === 3
              ? 85 + (day + day) * 13
              : day === 4
              ? 82 + (day + day) * 13
              : day === 5
              ? 75 + (day + day) * 13
              : 69 + (day + day) * 13),
      // left: props.chargerTripShedule === 'Trip Schedule' ? (day >= 3 && day <= 6 ? (props?.letList / 100) * (day===6?65 + (day + day) * 13:70 + (day + day) * 13) : (props?.letList / 100) * (90 + ((day + day) * 13))) : (props?.letList / 100) * (90 + ((day + day) * 13)),
      // left2:window.screen.width <= 1399?props.chargerTripShedule === 'Trip Schedule' ?(day === 6 ?(props?.letList/100)*(120 +((day+day) * 12)):(props?.letList/100)*(90 +((day+day) * 13))):(day === 6 ?(props?.letList/100)*(140 +(day * 12)):(props?.letList/100)*(100 +(day * 12)))
      // :props.chargerTripShedule === 'Trip Schedule' ?(day === 6 ?(props?.letList/100)*(120 +((day+day) * 12)):(props?.letList/100)*(90 +((day+day) * 13))):(day === 6 ?(props?.letList/100)*(130 +((day+day) * 12)):(props?.letList/100)*(110 +((day+day) * 12))),
      // left1: window.screen.width >= 1920 ? props.chargerTripShedule === 'Trip Schedule' ? (day === 6 ? 550 : day === 5 ? 455 : day === 4 ? 405 : day === 3 ? 350 : day === 2 ? 300 : day === 1 ? 250 : 220) :
      //     (day === 6 ? 500 : day === 5 ? 467 : day === 4 ? 425 : day === 3 ? 380 : day === 2 ? 325 : day === 1 ? 300 : 238) :
      //     props.chargerTripShedule === 'Trip Schedule' ? (day === 6 ? 350 : day === 5 ? 320 : day === 4 ? 285 : day === 3 ? 255 : day === 2 ? 220 : day === 1 ? 190 : 155) :
      //         (day === 6 ? 370 : day === 5 ? 335 : day === 4 ? 298 : day === 3 ? 265 : day === 2 ? 230 : day === 1 ? 200 : 175),
      // right: 10,
      backgroundColor: "#fff",
      borderWidth: 2,
    },
    xAxis: {
      type: "time",
      position: "top",
      // data: [1596507060.000, 1596507260.000],
      // boundaryGap: [props.gap+'%', '0%'],
      boundaryGap:
        window.screen.width >= 1920 ? ["1.5%", ".5%"] : ["2.5%", "1.5%"],
      splitLine: {
        lineStyle: {
          color: ["#E9EDFF"],
        },
      },
      axisLine: {
        show: false,
      },
      axisTick: {
        show: true,
        lineStyle: {
          // color: '#929ABA'
          color: "#929ABA",
        },
        inside: true,
      },

      axisLabel: {
        color: "#000000",
        inside: true,
        align: "center",
        padding: ukDate === "metric" ? [0, 0, 0, 0] : [0, 0, 0, 21],
        // left:10,
        formatter: function (value) {
          return ukDate === "metric"
            ? moment(value).format("HH:mm")
            : moment(value).format("hh:mm a");
        },
      },

      minInterval: 3600 * 1000 * 3,
      maxInterval: 3600 * 1000 * 3,
      interval: 3600 * 1000 * 3,
      // gridIndex: 0,
      // inverse: props.rowDataTable.length<20?true:false,
    },
    yAxis: {
      splitLine: { show: false },
      axisTick: { show: false },
      // splitLine: {show: true},

      axisLine: { show: false },
      boundaryGap: ["3%", "3%"],
      // axisLabel: {show: false},
      min: 0,
      type: "value",
      axisLabel: {
        show: false,
        formatter: "{value} °C",
      },
      // name: 'Y-Axis',
      // nameLocation: 'middle',
      // nameGap: 50,
      max: rawData.vehicleList.data.length,
      // nameGap:200
      // max:2
      gridIndex: 0,
      // inverse: props.rowDataTable.length < 20 ? true : false,
      inverse: true,
    },
    series: [
      {
        id: "flightData",
        type: "custom",
        // gridIndex: 0,
        // inverse: true,
        renderItem: renderGanttItem,
        dimensions:
          props.chargerTripShedule === "Trip Schedule"
            ? rawData.vehicleSchedule.dimensions
            : rawData.chargerSchedule.dimensions,
        encode: {
          x: [startTime, endTime],
          y: scheduleid,
          tooltip: [name, startTime, endTime],
        },
        data:
          props.chargerTripShedule === "Trip Schedule"
            ? rawData.vehicleSchedule.data
            : rawData.chargerSchedule.data,
      },
      {
        type: "custom",
        renderItem: renderAxisLabelItem1,
        dimensions:
          props.chargerTripShedule === "Trip Schedule"
            ? rawData.vehicleList.dimensions
            : rawData.chargerList.dimensions,
        encode: {
          x: 0, // Then this series will not controlled by x.
          y: 0,
        },
        data: echarts.util.map(
          props.chargerTripShedule === "Trip Schedule"
            ? rawData.vehicleList.data
            : rawData.chargerList.data,
          function (item, index) {
            return [index].concat(item);
          }
        ),
      },
    ],
  });

  function renderGanttItem(params, api) {
    // debugger
    var categoryIndex = api.value(scheduleid);
    var timeArrival = api.coord([api.value(startTime), categoryIndex]);
    var timeDeparture = api.coord([api.value(endTime), categoryIndex]);
    var barLength = timeDeparture[0] - timeArrival[0];

    // Get the heigth corresponds to length 1 on y axis.
    var barHeight = 25; //api.size([0, 1])[1] * HEIGHT_RATIO;
    var x = timeArrival[0];
    var y = timeArrival[1] - barHeight;
    // console.log('wi',x)
    var flightNumber = api.value(3) + "";
    var flightNumberWidth = echarts.format.getTextRect(flightNumber).width;
    // console.log(flightNumberWidth)
    // var text=flightNumber
    var text =
      barLength > flightNumberWidth + 40 && x + barLength >= 180
        ? flightNumber
        : flightNumber;

    var rectNormal = clipRectByRect(params, {
      x: x,
      y: y,
      width: barLength < 58 ? barLength : barLength,
      height: barHeight,
    });
    // var rectVIP = clipRectByRect(params, {
    // x: x, y: y, width: (barLength) / 2, height: barHeight
    // });
    var rectText = clipRectByRect(params, {
      x: x,
      y: y,
      width: barLength < 58 ? barLength : barLength,
      height: barHeight,
    });

    function clipRectByRect(params, rect) {
      // console.log('test',params.coordSys.width)
      return echarts.graphic.clipRectByRect(rect, {
        x: params.coordSys.x,
        y: params.coordSys.y,
        // r: [5,5,5,5],
        width: params.coordSys.width,
        height: params.coordSys.height,
        r: [5, 5, 5, 5],
      });
    }

    return {
      type: "group",
      children: [
        {
          type: "rect",
          ignore: !rectNormal,
          // shape:rectNormal,

          shape: {
            x: x,
            y: y,
            width: barLength < 58 ? barLength : barLength,
            height: barHeight > 100 ? 100 : barHeight,
            r: [5, 5, 5, 5],
          },
          style: api.style({
            // fill: '#FC9B9B',
            fill:
              props.chargerTripShedule === "Trip Schedule"
                ? "#6A9930"
                : "#759840",
            borderColor: "#f0f",
          }),
        },
        // {
        // type: 'rect',
        // ignore: !rectVIP && !api.value(4),
        // shape: rectVIP,
        // style: api.style({fill: '#ddb30b'})
        // },
        {
          type: "rect",
          ignore: !rectText,
          shape: rectText,
          style: api.style({
            fill: "transparent",
            stroke: "transparent",
            text: text,
            textFill: "#fff",
            focus: "none",
            hover: "none",
            opacity: 1,
            showHoverEffect: "0",
            plotHoverEffect: "0",
          }),
        },
      ],
    };
  }
  const [chartPopupData, setChartPopupData] = useState(true);
  const onChartClick = (params) => {
    //   console.log(params)
    let dataVal = {
      dataVa: params.data,
      stateP: chartPopupData,
    };

    props.popupCallBack(dataVal);
  };

  const onEvents = {
    click: onChartClick,
  };
  // const chartRef = useRef<HTMLDivElement>()
  // const size = useComponentSize(chartRef);
  // useEffect(() => {
  //     const chart = chartRef.current && echarts.getInstanceByDom(chartRef.current);
  //     if (chart) {
  //       chart.resize();
  //     }
  //   }, [size]);

  return (
    <ReactECharts
      // ref="chinaMapChart"
      echarts={echarts}
      //option={this.getOption()}
      // notMerge={true}
      // lazyUpdate={true}

      theme={"theme_name"}
      //onChartReady={this.onChartReadyCallback}
      //onEvents={EventsDict}
      style={{
        height: "100%",
        width: "100%",
      }}
      // opts={{renderer: 'svg'}} // use svg to render the chart.
      onEvents={onEvents}
      option={options()}
    />
  );
};

function renderAxisLabelItem1(params, api) {
  //  console.log('day',day)
  var y = api.coord([0, api.value(0)])[1];
  if (y < params.coordSys.y + 5) {
    return;
  }

  return {
    type: "group",
    position: [0, y],
    children: [
      {
        type: "path",
        shape: {
          // d: " M 2,2 L 60,0 Z",
          d:
            params?.dataIndex <= rowCount
              ? "M0,0 L0,-20 L30,-20 C40,-20 40,-1 50,-1 L90,-1 L90,0 Z"
              : "",
          // d: 'M0,0 L0,-0.09 L390,-0.09 L390,0 Z',
          // d: 'M1,1 L1,0 Z',
          x: 0,
          y: 0,
          width:
            window.screen.width <= 1399
              ? (graphWidth / 100) * (82 + day * 2.6)
              : window.screen.width >= 1400 && window.screen.width <= 1440
              ? (graphWidth / 100) * (82.2 + day * 2.6)
              : window.screen.width >= 1600 && window.screen.width <= 1680
              ? (graphWidth / 100) * (82.5 + day * 2.6)
              : (graphWidth / 100) * (82.8 + day * 2.6), //85.5 //2.5 for
          widthf:
            window.screen.width <= 1399
              ? tripSchedule === "Trip Schedule"
                ? (graphWidth / 100) * (80.2 + day * 2.6)
                : (graphWidth / 100) * (82 + day * 2.6)
              : tripSchedule === "Trip Schedule"
              ? (graphWidth / 100) * (81.5 + day * 2.6)
              : (graphWidth / 100) * (82.8 + day * 2.6), //85.5 //2.5 for
          widthv:
            window.screen.width >= 1920
              ? tripSchedule === "Trip Schedule"
                ? rowCount > 5
                  ? osCheck === "Linux x86_64"
                    ? day === 6
                      ? 1700 + day * 33
                      : day === 5
                      ? 1450 + day * 31
                      : day === 4
                      ? 1442 + day * 30
                      : day === 3
                      ? 1437 + day * 27
                      : day === 2
                      ? 1430 + day * 22
                      : day === 1
                      ? 1420 + day * 9
                      : day === 0
                      ? 1385 + day * 1
                      : 1385 + day * 0
                    : day === 6
                    ? 1700 + day * 33
                    : day === 5
                    ? 1515 + day * 31
                    : day === 4
                    ? 1503 + day * 30
                    : day === 3
                    ? 1492 + day * 27
                    : day === 2
                    ? 1489 + day * 22
                    : day === 1
                    ? 1476 + day * 9
                    : day === 0
                    ? 1439 + day * 1
                    : 1435 + day * 0
                  : osCheck === "Linux x86_64"
                  ? day === 6
                    ? 1700 + day * 33
                    : day === 5
                    ? 1465 + day * 31
                    : day === 4
                    ? 1455 + day * 30
                    : day === 3
                    ? 1450 + day * 27
                    : day === 2
                    ? 1442 + day * 22
                    : day === 1
                    ? 1433 + day * 9
                    : day === 0
                    ? 1395 + day * 1
                    : 1400 + day * 0
                  : day === 6
                  ? 1700 + day * 33
                  : day === 5
                  ? 1535 + day * 31
                  : day === 4
                  ? 1520 + day * 30
                  : day === 3
                  ? 1515 + day * 27
                  : day === 2
                  ? 1502 + day * 22
                  : day === 1
                  ? 1492 + day * 9
                  : day === 0
                  ? 1455 + day * 1
                  : 1400 + day * 0
                : rowCount > 5
                ? osCheck === "Linux x86_64"
                  ? day === 6
                    ? 1500 + day * 33
                    : day === 5
                    ? 1465 + day * 33
                    : day === 4
                    ? 1465 + day * 30
                    : day === 3
                    ? 1461 + day * 27
                    : day === 2
                    ? 1452 + day * 22
                    : day === 1
                    ? 1444 + day * 9
                    : day === 0
                    ? 1410 + day * 1
                    : 1200 + day * 0
                  : day === 6
                  ? 1700 + day * 33
                  : day === 5
                  ? 1527 + day * 33
                  : day === 4
                  ? 1525 + day * 30
                  : day === 3
                  ? 1515 + day * 27
                  : day === 2
                  ? 1509 + day * 22
                  : day === 1
                  ? 1499 + day * 9
                  : day === 0
                  ? 1462 + day * 1
                  : 1200 + day * 0
                : osCheck === "Linux x86_64"
                ? day === 6
                  ? 1500 + day * 33
                  : day === 5
                  ? 1479 + day * 33
                  : day === 4
                  ? 1479 + day * 30
                  : day === 3
                  ? 1472 + day * 27
                  : day === 2
                  ? 1465 + day * 22
                  : day === 1
                  ? 1456 + day * 9
                  : day === 0
                  ? 1420 + day * 1
                  : 1200 + day * 0
                : day === 6
                ? 1700 + day * 33
                : day === 5
                ? 1545 + day * 33
                : day === 4
                ? 1544 + day * 30
                : day === 3
                ? 1540 + day * 27
                : day === 2
                ? 1524 + day * 22
                : day === 1
                ? 1514 + day * 9
                : day === 0
                ? 1477 + day * 1
                : 1200 + day * 0
              : //windows 1399
              osCheck === "Linux x86_64"
              ? tripSchedule === "Trip Schedule"
                ? rowCount > 5
                  ? day === 6
                    ? 1080 + day * 33
                    : day === 5
                    ? 938 + day * 31
                    : day === 4
                    ? 941 + day * 30
                    : day === 3
                    ? 950 + day * 27
                    : day === 2
                    ? 957 + day * 22
                    : day === 1
                    ? 962 + day * 9
                    : day === 0
                    ? 940 + day * 1
                    : 1100 + day * 0
                  : day === 6
                  ? 1080 + day * 33
                  : day === 5
                  ? 938 + day * 31
                  : day === 4
                  ? 941 + day * 30
                  : day === 3
                  ? 950 + day * 27
                  : day === 2
                  ? 957 + day * 22
                  : day === 1
                  ? 962 + day * 9
                  : day === 0
                  ? 940 + day * 1
                  : 1100 + day * 0
                : rowCount > 5
                ? day === 6
                  ? 1080 + day * 33
                  : day === 5
                  ? 960 + day * 31
                  : day === 4
                  ? 963 + day * 30
                  : day === 3
                  ? 972 + day * 27
                  : day === 2
                  ? 980 + day * 22
                  : day === 1
                  ? 985 + day * 9
                  : day === 0
                  ? 962 + day * 1
                  : 1100 + day * 0
                : day === 6
                ? 1080 + day * 33
                : day === 5
                ? 960 + day * 31
                : day === 4
                ? 963 + day * 30
                : day === 3
                ? 972 + day * 27
                : day === 2
                ? 980 + day * 22
                : day === 1
                ? 985 + day * 9
                : day === 0
                ? 962 + day * 1
                : 1100 + day * 0
              : tripSchedule === "Trip Schedule"
              ? rowCount > 5
                ? day === 6
                  ? 1080 + day * 33
                  : day === 5
                  ? 1032 + day * 31
                  : day === 4
                  ? 1038 + day * 30
                  : day === 3
                  ? 1042 + day * 27
                  : day === 2
                  ? 1048 + day * 22
                  : day === 1
                  ? 1048 + day * 9
                  : day === 0
                  ? 1025 + day * 1
                  : 1100 + day * 0
                : day === 6
                ? 1080 + day * 33
                : day === 5
                ? 1030 + day * 31
                : day === 4
                ? 1033 + day * 30
                : day === 3
                ? 1038 + day * 27
                : day === 2
                ? 1043 + day * 22
                : day === 1
                ? 1043 + day * 9
                : day === 0
                ? 1020 + day * 1
                : 1020
              : rowCount > 5
              ? day === 6
                ? 1080 + day * 33
                : day === 5
                ? 1052 + day * 31
                : day === 4
                ? 1055 + day * 30
                : day === 3
                ? 1060 + day * 27
                : day === 2
                ? 1065 + day * 22
                : day === 1
                ? 1065 + day * 9
                : day === 0
                ? 1042 + day * 1
                : 1100 + day * 0
              : day === 6
              ? 1080 + day * 33
              : day === 5
              ? 1052 + day * 31
              : day === 4
              ? 1055 + day * 30
              : day === 3
              ? 1060 + day * 27
              : day === 2
              ? 1065 + day * 22
              : day === 1
              ? 1065 + day * 9
              : day === 0
              ? 1042 + day * 1
              : 1100 + day * 0,

          height: 1,
          right: 0,
          layout: "cover",
        },
        style: {
          fill: "#fff",
          strokeWidth: "1px",
          stroke: "#CCCCCC",
        },
      },
      {
        type: "text",
        style: {
          // x: tripSchedule === 'Trip Schedule' ? 5 : 0,
          x: 0,
          y: -16,
          text: api.value(2),
          textVerticalAlign: "bottom",
          textAlign: "left",
          textFill: "#000",
          fontSize: 13,
          fontFamily: "Montserrat",
        },
      },
      {
        type: "text",
        style: {
          x: 0,
          y: 0,
          position: "absolute",
          text: api.value(3),
          textVerticalAlign: "bottom",
          textAlign: "left",
          textFill: "#696969",
          fontSize: 13,
          fontFamily: "Montserrat",
          zIndex: 60,
        },
      },
      // , {
      // type: 'text',
      // style: {
      // x: 75,
      // y: -2,
      // textVerticalAlign: 'bottom',
      // textAlign: 'center',
      // text: api.value(2),
      // textFill: '#000'
      // }
      // }
    ],
  };
}

export default Gantt;
